var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReportFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1507_4431",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 17
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1507_4431)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.7833 11.166H10.6667C10.4778 11.166 10.3194 11.1021 10.1917 10.9743C10.0639 10.8466 10 10.6882 10 10.4993C10 10.3105 10.0639 10.1521 10.1917 10.0243C10.3194 9.89657 10.4778 9.83268 10.6667 9.83268H12.7833L12.1833 9.23268C12.0611 9.11046 12 8.95768 12 8.77435C12 8.59102 12.0667 8.43268 12.2 8.29935C12.3222 8.17713 12.4778 8.11602 12.6667 8.11602C12.8556 8.11602 13.0111 8.17713 13.1333 8.29935L14.8667 10.0327C14.9333 10.0993 14.9806 10.1716 15.0083 10.2493C15.0361 10.3271 15.05 10.4105 15.05 10.4993C15.05 10.5882 15.0361 10.6716 15.0083 10.7493C14.9806 10.8271 14.9333 10.8993 14.8667 10.966L13.1333 12.6993C13.0111 12.8216 12.8583 12.8855 12.675 12.891C12.4917 12.8966 12.3333 12.8327 12.2 12.6993C12.0778 12.5771 12.0167 12.4216 12.0167 12.2327C12.0167 12.0438 12.0778 11.8882 12.2 11.766L12.7833 11.166ZM7.33333 8.69935L10.6333 4.49935H4.03333L7.33333 8.69935ZM6 9.16602L2.15 4.24935C2.09444 4.18268 2.05556 4.11324 2.03333 4.04102C2.01111 3.96879 2 3.89935 2 3.83268C2 3.6549 2.06389 3.49935 2.19167 3.36602C2.31944 3.23268 2.47778 3.16602 2.66667 3.16602H12C12.1889 3.16602 12.3472 3.23268 12.475 3.36602C12.6028 3.49935 12.6667 3.6549 12.6667 3.83268C12.6667 3.89935 12.6556 3.96879 12.6333 4.04102C12.6111 4.11324 12.5722 4.18268 12.5167 4.24935L8.66667 9.16602V13.166C8.66667 13.3549 8.60278 13.5132 8.475 13.641C8.34722 13.7688 8.18889 13.8327 8 13.8327H6.66667C6.47778 13.8327 6.31944 13.7688 6.19167 13.641C6.06389 13.5132 6 13.3549 6 13.166V9.16602Z",
    fill: "black",
    fillOpacity: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportFilter);
export default __webpack_public_path__ + "static/media/ReportFilter.b723f3a6042d50343b07dc3b25343480.svg";
export { ForwardRef as ReactComponent };